/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-labels */

import { DisplayConditions } from '@/types/general/DisplayConditionsType'

export function passesDisplayConditions(record: any, conditions: DisplayConditions|null): boolean {
    if (!record || !conditions || !conditions.length) // passes without record or in case of empty conditions
        return true

    groupLoop: for (const group of conditions) {
        for (const condition of group) {
            switch (condition.operator) {
            case 'empty':
                if (record[condition.field] !== null || typeof(record[condition.field]) !== 'undefined')
                    continue groupLoop
                break
            case 'not-empty':
                if (record[condition.field] === null || typeof(record[condition.field]) === 'undefined')
                    continue groupLoop
                break
            case 'equals':
                if (record[condition.field] !== condition.value)
                    continue groupLoop
                break
            case 'not-equals':
                if (record[condition.field] === condition.value)
                    continue groupLoop
                break
            case 'is-true':
                if (record[condition.field] !== true)
                    continue groupLoop
                break
            case 'is-false':
                if (record[condition.field] !== false)
                    continue groupLoop
                break
            case 'includes':
                if (!record[condition.field]?.includes(condition.value))
                    continue groupLoop
                break
            case 'not-includes':
                if (record[condition.field]?.includes(condition.value))
                    continue groupLoop
                break
            case 'contains':
                if (!record[condition.field]?.contains(condition.value))
                    continue groupLoop
                break
            case 'not-contains':
                if (record[condition.field]?.contains(condition.value))
                    continue groupLoop
                break
            case 'in':
                if (!condition.value.includes(record[condition.field]))
                    continue groupLoop
                break
            default:
                // unknown operator fails
                continue groupLoop
            }
        }

        // at least one group needs to pass
        return true
    }

    // no group passed
    return false
}
